export default __webpack_public_path__ + "static/media/StoreFront.f6194c43.webm";